import { flattenDeep, values } from "lodash-es";

export interface ResponseErrors {
    [field: string]: string[];
}

export class Errors {
    protected _errors: ResponseErrors = {};

    constructor(errors = {}) {
        this._errors = errors;
    }

    public errors() {
        return this._errors;
    }

    public get(field: string) {
        return this._errors[field] || [];
    }

    public flatten(): string[] {
        return flattenDeep(values(this._errors));
    }

    public count(): number {
        return this.flatten().length;
    }
}
